import FragmentSerializer from 'client-portal/serializers/-fragment';
import classic from 'ember-classic-decorator';

@classic
export default class PracticeWebsiteMarketingFee extends FragmentSerializer {}
